import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import 'react-owl-carousel2/src/owl.carousel.css';
import App from './app/App';
// import './assets/scss/App.scss';
import reportWebVitals from './reportWebVitals';

// ✅ SEO Provider
import { HelmetProvider } from 'react-helmet-async';

// ✅ Vercel Analytics & Speed Insights
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

// React 18 way to create root
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <App />
    <Analytics />
    <SpeedInsights />
  </HelmetProvider>
);

reportWebVitals();
